import { Badge } from "antd";
import moment from "moment";
import { useParams } from "react-router-dom";
import CardTitle from "../../../../../components/common/CardTitle";
import Loader from "../../../../../components/ui/Loader";
import { dateFormat, timeFormat } from "../../../../../constants/constants";
import { useGetLogByUserIdQuery } from "../../../../../features/administrative-setting/administrativeSetting";
import useError from "../../../../../hooks/useError";
import UserIcon from "../_icons/UserIcon";

export default function UserDetailsLog() {
  const { id } = useParams();
  const { isLoading, isError, error, data } = useGetLogByUserIdQuery(
    {
      params: {
        id: Number(id),
        skip: 0,
        limit: 0,
      },
    },
    {
      skip: !id,
    }
  );
  useError(isError, error, "Get user log fail");

  const logDetails = data?.data?.logs;

  if (isLoading) {
    return <Loader />;
  }

  if (!logDetails?.length) {
    return null;
  }

  return (
    <div>
      <CardTitle>User Log</CardTitle>

      {logDetails?.map((el, index) => (
        <li className="mb-0 last:mb-0 flex py-3 rounded-sm px-6">
          <div className="w-8 relative">
            <Badge
              status={index === 0 ? "processing" : "default"}
              className="timeline-badge relative -top-[1px] z-10"
              color="#FEA735"
            />
          </div>

          <div className="flex-1 ">
            <div className="text-[#C19C60] text-sm font-semibold leading-6">
              {moment(el?.created_at)?.format(timeFormat)} -{" "}
              {moment(el?.created_at)?.format(dateFormat)}
            </div>
            <p
              className="text-slate-600 text-sm font-normal"
              dangerouslySetInnerHTML={{ __html: el?.log_msg || "" }}
            />
            <div className="text-slate-400 text-sm font-medium italic flex items-center gap-1 mt-0.5">
              <UserIcon />
              {el?.changedByUser?.name} - {el?.changedByUser?.department?.name}
            </div>
          </div>
        </li>
      ))}
    </div>
  );
}
